import React, { Suspense, lazy } from "react";
import { Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";

const PlanSubscripition = lazy(() => import("./pages/Signup/PlanSubscription"));
const ClientInfo = lazy(() => import("./pages/Signup/ClientInfo"));
const Steps = lazy(() => import("./pages/Signup/Steps"));

export default function OnBoardPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
       <Switch>
          <ContentRoute path="/signup/plans/:qrcode?" component={PlanSubscripition} />
          <ContentRoute path="/signup/client-info/:plan_id/:qrcode?" component={ClientInfo} />
          <ContentRoute path="/signup/steps/:plan_id/:token/:qrcode?" component={Steps} />
       </Switch>
    </Suspense>
  );
}